import styled from "styled-components"

const Blocker = styled.div`
	${props => props.blocked ? `
    opacity: 0.2;
    pointer-events: none;
  ` : ''}
`

export default Blocker